import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProfileData } from "../../../redux/slices/profileslice";
import { getLeads } from "../services/lead.service";
import { createInvoice, previewInvoice } from "../services/invoice.service";
import { changeStatus } from "../services/lead.service";
import { productListOptions } from "../services/products.service";
import { profileDetails } from "../services/user.service";
import Swal from "sweetalert2";
import { LEADS_STATUS, SWAL_SETTINGS, ROLE } from "../../../utils/Constants";
import moment from "moment";
import {
  capitalizeFirstLetter,
  handleServerValidations,
  removeSpecialCharacter,
  getUser,
} from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";

const LeadCard = ({ lead, onInvoice, isInvoiceVisible = true }) => {
  const { buyer_id, product_id, createdAt } = lead;
  const name = buyer_id?.name;
  const leadID = lead?._id;
  const product = lead?.product_id?.title

  console.log(product,"ads2123sadasd")
  const time = moment(createdAt).format("MMM DD, YYYY hh:mm A");
  const avatarUrl = buyer_id?.profile_image || "";
  const { t } = useTranslation();

  const [leadStatus] = useState(
    Object.keys(LEADS_STATUS).map((item) => {
      return { label: item, value: LEADS_STATUS[item] };
    }),
  );

  const [selectedStatus, setSelectedStatus] = useState(lead.status || "new");
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);

  // 🔹 Dropdown change → open confirmation modal
  const ChangeStatus = (statusValue) => {
    if (!statusValue) return;
    setPendingStatus(statusValue);
    setShowConfirm(true);
  };

  // 🔹 Confirm → API call (same logic as before)
  const confirmChangeStatus = () => {
    const formData = new FormData();
    formData.append("o_id", JSON.stringify([leadID]));
    formData.append("status", pendingStatus);

    changeStatus(formData)
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });

          setSelectedStatus(pendingStatus);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.log("error===>", error);
      });

    setShowConfirm(false);
  };
 

  return (
    <>
      <div className="bg-white p-[15px] md:p-[30px] rounded-[10px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] border !border-zinc-100">
        <div className="flex justify-between items-start space-x-3">
          {/* User Info */}
          <div className="flex items-center space-x-4">
            <div className="md:h-[75px] md:w-[75px] h-[50px] w-[50px] rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
              <img
                src={avatarUrl}
                alt={name}
                className="h-full w-full object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/User.png";
                }}
              />
            </div>
            <div>
              <h3 className="headings-h5 mb-2 text-zinc-950 leading-none">
                {capitalizeFirstLetter(name || "-")}
              </h3>
              <p className="body-md text-zinc-500 leading-snug">
                {product || t('advertiser.leads.product_info_unavailable')}
              </p>
              <p className="body-md text-zinc-500 leading-snug">{time}</p>
            </div>
          </div>

          {/* Status Section */}
          <div>
            {selectedStatus === "new" ? (
              <select
                className="form-control-custom !w-[130px] !p-[5px] text-[14px] medium !h-[30px] !rounded-[4px]"
                value={selectedStatus}
                onChange={(e) => ChangeStatus(e.target.value)}
              >
                <option value="">{t('advertiser.leads.type')}</option>
                {leadStatus.map((option, i) => (
                  <option key={i} value={option.value}>
                    {removeSpecialCharacter(option.label)}
                  </option>
                ))}
              </select>
            ) : (
              <span className="text-sm font-medium text-zinc-800 px-3 py-1 bg-gray-100 rounded">
                {removeSpecialCharacter(
                  Object.keys(LEADS_STATUS).find(
                    (key) => LEADS_STATUS[key] === selectedStatus,
                  ),
                )}
              </span>
            )}
          </div>
        </div>

        {/* Create Invoice Button */}
        {isInvoiceVisible && (
          <div className="mt-4 pt-4 border-t border-zinc-100">
            {selectedStatus === "sold" || selectedStatus === LEADS_STATUS.SOLD ? (
              <button
                disabled
                className="btn btn-outline border-zinc-200 text-zinc-400 bg-gray-50 cursor-not-allowed opacity-75 font-semibold"
              >
                Invoice Sent
              </button>
            ) : (
              <button onClick={() => onInvoice(lead)} className="btn btn-pri">
                {t('advertiser.invoice.create_invoice')}
              </button>
            )}
          </div>
        )}
      </div>

      {/* 🔹 Custom Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-[16px] p-[30px] w-[400px]">
            <div className="text-center flex items-center justify-center flex-col gap-[15px]">
              <img src="/images/logout.png" alt="confirm" />

              <div className="flex flex-col gap-[10px]">
                <h1 className="headings-h1 text-zinc-800">
                  {t("advertiser.leads.confirm_status_change")}
                </h1>
                <p className="body-lg text-gray-500">
                  {t("advertiser.leads.are_you_sure_status")}
                </p>
              </div>

              <div className="flex items-center gap-[15px] w-full mt-[15px]">
                <button
                  className="btn btn-outline flex-1"
                  onClick={confirmChangeStatus}
                >
                  {t("advertiser.leads.btn_yes")}
                </button>

                <button
                  className="btn btn-pri flex-1"
                  onClick={() => setShowConfirm(false)}
                >
                  {t("advertiser.leads.btn_no")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

function PurchaseLeads() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const reduxUserData = useSelector((state) => state.profile.profileData);
  const [profileData, setProfileData] = useState(null);
  const storedUser = getUser(ROLE.ADVERTISER) || getUser() || {};
  const currentUser = { ...storedUser, ...(reduxUserData || {}), ...(profileData || {}) };

  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);
  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  const isInvoiceVisible = String(globalData?.show_invoice) === "true";

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  console.log("productOptions", productOptions);
  const [invoiceForm, setInvoiceForm] = useState({
    items: [],
    billing_address: "",
    shipping_address: "",
  });

  const handleOpenInvoice = (lead) => {
    setSelectedLead(lead);
    setShowPreview(false);
    setPreviewPdfUrl(null);

    let apiProducts = [];
    if (Array.isArray(lead?.products) && lead.products.length > 0) {
      apiProducts = lead.products;
    } else if (lead?.product_id) {
      if (typeof lead.product_id === "object") {
        apiProducts = [lead.product_id];
      } else if (typeof lead.product_id === "string") {
        const matched = productOptions.find((p) => p._id === lead.product_id);
        if (matched) {
          apiProducts = [matched];
        } else {
          apiProducts = [{ _id: lead.product_id, title: "" }];
        }
      }
    }

    const mappedItems = apiProducts.map((product) => ({
      product_id: product._id || product.id || "",
      product_name: product.title || product.name || "",
      quantity: 1,
      hsn: product.hsn || "8523",
      price: product.price || 0,
      is_custom: true,
    }));

    setInvoiceForm({
      items:
        mappedItems.length > 0
          ? mappedItems
          : [
              {
                product_id: "",
                product_name: "",
                quantity: 1,
                hsn: "8523",
                price: 0,
                is_custom: true,
              },
            ],
      billing_address: lead?.buyer_id?.address || "",
      shipping_address: lead?.buyer_id?.address || "",
    });

    document.getElementById("create-invoice").showModal();
  };

  const handleInvoiceItemChange = (index, field, value) => {
    const newItems = [...invoiceForm.items];
    newItems[index][field] = value;
    setInvoiceForm({ ...invoiceForm, items: newItems });
  };

  const handleAddInvoiceItem = () => {
    setInvoiceForm({
      ...invoiceForm,
      items: [
        ...invoiceForm.items,
        {
          product_id: null,
          product_name: "",
          quantity: 1,
          hsn: "",
          price: 0,
          is_custom: true,
        }

      ],
    });
  };

  const handleRemoveInvoiceItem = (index) => {
    const newItems = [...invoiceForm.items];
    newItems.splice(index, 1);
    setInvoiceForm({ ...invoiceForm, items: newItems });
  };

  const calculateTotal = () => {
    return invoiceForm.items.reduce((acc, item) => {
      const price = parseFloat(item.price) || 0;
      const qty = parseFloat(item.quantity) || 1;
      return acc + price * qty;
    }, 0);
  };

  const handlePreviewInvoice = async (e) => {
    e.preventDefault();
    if (!selectedLead) return;

    try {
      setPreviewLoading(true);
      const payload = {
        customer_id: selectedLead.buyer_id?._id,
        billing_address: invoiceForm.billing_address,
        shipping_address: invoiceForm.shipping_address,
        items: invoiceForm.items,
      };

      const resp = await previewInvoice(payload);
      if (resp.success && resp.data?.pdf_base64) {
        setPreviewPdfUrl(resp.data.pdf_base64);
        setShowPreview(true);
      } else {
        Swal.fire({
          icon: "error",
          text: resp.message || "Failed to generate preview",
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      console.error("Invoice preview error:", error);
      Swal.fire({
        icon: "error",
        text: error.message || "Something went wrong",
        ...SWAL_SETTINGS,
      });
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleGenerateInvoice = async (e) => {
    e.preventDefault();
    if (!selectedLead) return;

    try {
      const payload = {
        customer_id: selectedLead.buyer_id?._id,
        billing_address: invoiceForm.billing_address,
        shipping_address: invoiceForm.shipping_address,
        items: invoiceForm.items,
      };

      const resp = await createInvoice(payload);
      if (resp.success) {
        Swal.fire({
          icon: "success",
          text: resp.message || t('advertiser.invoice.success_msg'),
          ...SWAL_SETTINGS,
        });
        document.getElementById("create-invoice").close();
        if (selectedLead?._id) {
          const formData = new FormData();
          formData.append("o_id", JSON.stringify([selectedLead._id]));
          formData.append("status", "sold");
          changeStatus(formData).finally(() => fetchLeads());
        } else {
          fetchLeads();
        }
      } else {
        Swal.fire({
          icon: "error",
          text: resp.message || t('advertiser.invoice.fail_msg'),
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      console.error("Invoice creation error:", error);
      Swal.fire({
        icon: "error",
        text: error.message || "Something went wrong",
        ...SWAL_SETTINGS,
      });
    }
  };

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const resp = await getLeads();
      if (resp.success) {
        setLeads(resp?.data?.leads || []);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchProductOptions = async () => {
    try {
      const resp = await productListOptions();
      if (resp.success) {
        setProductOptions(resp.data?.list || []);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };


  useEffect(() => {
    fetchLeads();
    fetchProductOptions();
    profileDetails()
      .then((res) => {
        if (res && res.data) {
          setProfileData(res.data);
          dispatch(addProfileData(res.data));
        }
      })
      .catch((err) => console.log("Profile fetch err:", err));
  }, []);

  return (
    <>
      <div className="dashbaord-bg py-10">
        <div className="container">
          <h1 className="headings-h1 text-zinc-950 border-b border-gray-200 pb-[15px] mb-[30px]">
            {t('advertiser.leads.heading')}
          </h1>

          <div className="flex items-center flex-wrap gap-[15px] mb-8">
            <div className="search-box relative flex-1 max-w-[425px]">
              <input
                type="text"
                className="form-control-custom !pr-[50px] min-w-[250px] md:min-w-[425px]"
                placeholder={t('advertiser.leads.search_placeholder')}
              />
              <button className="absolute right-2 top-2">
                <img src="/images/search1.svg" alt="search" />
              </button>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-20">{t('advertiser.leads.loading')}</div>
          ) : leads.length === 0 ? (
            <div className="text-center py-20 bg-white rounded-[10px] shadow-sm">
              <h3 className="headings-h3 text-zinc-400">{t('advertiser.leads.no_leads')}</h3>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px] md:gap-[30px]">
              {leads.map((lead) => (
                <LeadCard
                  key={lead._id}
                  lead={lead}
                  onInvoice={handleOpenInvoice}
                  isInvoiceVisible={isInvoiceVisible}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <dialog id="create-invoice" className="modal p-[15px]">
        <div className={`modal-box ${showPreview ? "max-w-[820px]" : "max-w-[645px]"} !w-full transition-all duration-200`}>
          {showPreview ? (
            /* ─── INVOICE PREVIEW VIEW ─── */
            <div>
              <div className="flex items-center justify-between pb-3 border-b border-gray-100 mb-4">
                <div>
                  <h2 className="headings-h2 text-left text-zinc-900 font-bold">
                    Invoice Preview
                  </h2>
                  <p className="text-xs text-gray-500 mt-0.5">Review invoice details before generating</p>
                </div>
                <button
                  type="button"
                  onClick={() => setShowPreview(false)}
                  className="text-sm font-bold text-primary-500 hover:text-primary-600 flex items-center gap-1 bg-primary-50 hover:bg-primary-100 px-3 py-1.5 rounded-lg transition-all"
                >
                  ← Edit Invoice
                </button>
              </div>

              <div className="w-full bg-gray-50 rounded-xl overflow-hidden border border-gray-200">
                {previewPdfUrl ? (
                  <iframe
                    src={`${previewPdfUrl}#toolbar=0&navpanes=0`}
                    className="w-full h-[500px] border-0 rounded-xl"
                    title="Invoice Preview"
                  />
                ) : (
                  <div className="flex items-center justify-center h-[450px]">
                    <p className="text-gray-400 font-medium">Generating preview...</p>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-100 mt-4">
                <button
                  type="button"
                  onClick={() => setShowPreview(false)}
                  className="btn btn-outline flex-1 border-gray-300 text-gray-700"
                >
                  ← Back to Edit
                </button>

                <button
                  type="button"
                  onClick={handleGenerateInvoice}
                  className="btn btn-pri flex-1"
                >
                  {t('advertiser.invoice.generate_invoice')}
                </button>
              </div>
            </div>
          ) : (
            /* ─── INVOICE FORM VIEW ─── */
            <>
              <h2 className="headings-h1 text-left text-zinc-800 mb-4">
                {t('advertiser.invoice.create_invoice')}
              </h2>

              <form onSubmit={handleGenerateInvoice}>
                {/* Customer Field */}
                <div className="form-group">
                  <label>{t('advertiser.invoice.customer')}</label>
                  <div className="relative">
                    <input
                      type="text"
                      className="form-control-custom bg-gray-100"
                      value={selectedLead?.buyer_id?.name || ""}
                      readOnly
                    />
                  </div>
                </div>

                {/* Billing Address Field */}
                <div className="form-group">
                  <label>{t('advertiser.invoice.billing_address')}</label>
                  <input
                    type="text"
                    placeholder={t('advertiser.invoice.billing_address')}
                    className="form-control-custom"
                    value={invoiceForm.billing_address}
                    onChange={(e) =>
                      setInvoiceForm({
                        ...invoiceForm,
                        billing_address: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Shipping Address Field */}
                <div className="form-group">
                  <label>{t('advertiser.invoice.shipping_address')}</label>
                  <input
                    type="text"
                    placeholder={t('advertiser.invoice.shipping_address')}
                    className="form-control-custom"
                    value={invoiceForm.shipping_address}
                    onChange={(e) =>
                      setInvoiceForm({
                        ...invoiceForm,
                        shipping_address: e.target.value,
                      })
                    }
                  />
                </div>

                {/* Invoice Items Section */}
                {invoiceForm.items.map((item, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-12 gap-2.5 mb-3 items-center"
                  >
                    <div className="col-span-12 md:col-span-4 relative">
                      <div className="form-group m-0">
                        <label>{t('advertiser.invoice.invoice_items')}</label>

                        {item.is_custom ? (
                          <select
                            className="form-control-custom"
                            value={item.product_id || ""}
                            onChange={(e) => {
                              const selectedProduct = productOptions.find(
                                (p) => p._id === e.target.value
                              );

                              if (selectedProduct) {
                                handleInvoiceItemChange(index, "product_id", selectedProduct._id);
                                handleInvoiceItemChange(index, "product_name", selectedProduct.title);
                                handleInvoiceItemChange(index, "price", parseFloat(selectedProduct.price) || 0);
                              }
                            }}
                          >
                            <option value="">{t('advertiser.invoice.invoice_items')}</option>
                            {item.product_id && item.product_name && !productOptions.some((p) => p._id === item.product_id) && (
                              <option value={item.product_id}>{item.product_name}</option>
                            )}
                            {productOptions.map((product) => (
                              <option key={product._id} value={product._id}>
                                {product.title}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            className="form-control-custom bg-gray-50"
                            value={item.product_name}
                            readOnly
                          />
                        )}
                      </div>

                    </div>
                    <div className="col-span-6 md:col-span-2 relative">
                      <div className="form-group m-0">
                        <label>{t('advertiser.invoice.quantity')}</label>
                        <select
                          className="form-control-custom"
                          value={item.quantity}
                          onChange={(e) =>
                            handleInvoiceItemChange(
                              index,
                              "quantity",
                              Number(e.target.value),
                            )
                          }
                        >
                          {[1, 2, 3, 4, 5, 10].map((q) => (
                            <option key={q} value={q}>
                              {q}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-span-6 md:col-span-2">
                      <div className="form-group m-0">
                        <label>{t('advertiser.invoice.hsn')}</label>
                        <input
                          type="text"
                          placeholder="Enter"
                          className="form-control-custom"
                          value={item.hsn}
                          onChange={(e) =>
                            handleInvoiceItemChange(index, "hsn", e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-6 md:col-span-3">
                      <div className="form-group m-0">
                        <label>Price</label>
                        <input
                          type="number"
                          min="0"
                          placeholder="Price"
                          className="form-control-custom"
                          value={item.price ?? ""}
                          onChange={(e) =>
                            handleInvoiceItemChange(index, "price", parseFloat(e.target.value) || 0)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-6 md:col-span-1 flex justify-end md:justify-center">
                      <button
                        type="button"
                        onClick={() => handleRemoveInvoiceItem(index)}
                        className="mt-0 md:mt-[27px] w-[44px] h-[44px] flex-[0,0,44px] rounded-full bg-primary-400 flex items-center justify-center"
                      >
                        <img src="/images/cross.png" alt="cross" />
                      </button>
                    </div>
                  </div>
                ))}

                {/* Add More Button */}
                <button
                  type="button"
                  onClick={handleAddInvoiceItem}
                  className="add-more-btn headings-h5 text-secondary-500 mb-3"
                >
                  {t('advertiser.invoice.add_more')}
                </button>

                {/* Total and Action Buttons */}
                <div className="text-center mb-6">
                  <p className="headings-h5 text-zinc-950">
                    {t('advertiser.invoice.total')} {calculateTotal()}
                  </p>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={handlePreviewInvoice}
                    disabled={previewLoading}
                    className="btn btn-outline flex-1 border-primary-400 text-primary-500 hover:bg-primary-50 font-bold"
                  >
                    {previewLoading ? "Loading Preview..." : "Preview Invoice"}
                  </button>

                  <button type="submit" className="btn btn-pri flex-1">
                    {t('advertiser.invoice.generate_invoice')}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
        <form method="dialog">
          {/* Close button at the bottom, outside the main modal box */}
          <button className="bg-white subtitle-2 flex items-center gap-[5px] px-[15px] py-[10px] rounded-full mt-4">
            <img src="/images/close.svg" alt="close" />
            <span className="subtitle-2 bold">{t("advertiser.my_team.close")}</span>
          </button>
        </form>
      </dialog>
    </>
  );
}

export default PurchaseLeads;
